import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { listConnectors } from '@/api/content/connector'
import { ConnectorPage } from '@/components/ConnectorPage'

export const Route = createFileRoute('/_auth/$orgSlug/content/connector/')({
  validateSearch: z.object({
    connectorId: z.coerce.number().int().min(1).optional().catch(undefined)
  }),
  loader: () => listConnectors(),
  head: () => ({ meta: [{ title: 'Global Content - Snowvault' }] }),
  component: ConnectorPageRoute
})

function ConnectorPageRoute() {
  const navigate = Route.useNavigate()
  const { connectors } = Route.useLoaderData()
  const { connectorId } = Route.useSearch()
  const { userOrgProfile } = Route.useRouteContext().user
  if (!userOrgProfile) return null
  return (
    <ConnectorPage
      breadcrumbs={[{ label: 'Global Content' }, { label: 'Connectors' }]}
      connectors={connectors}
      userOrgProfile={userOrgProfile}
      initialConnectorId={connectorId}
      onClearConnectorId={connectorId !== undefined ? () => void navigate({ search: {} }) : undefined}
    />
  )
}
